import { Component } from '@angular/core';

@Component({
  selector: 'app-salfa-info-continuidad-laboral',
  templateUrl: './salfa-info-continuidad-laboral.component.html',
  styleUrls: ['./salfa-info-continuidad-laboral.component.scss']
})
export class SalfaInfoContinuidadLaboralComponent {

}
